import request from '@/utils/request'

let Requirement_hallApi = {

  /*需求大厅列表*/
  list(data) {
    return request._post('/shop/plus.requirement_hall.Index/index', data);
},
/*添加需求大厅*/
add(data) {
    return request._post('/shop/plus.requirement_hall.Index/add', data);
},
/*修改需求大厅*/
edit(data) {
    return request._post('/shop/plus.requirement_hall.Index/edit', data);
},
/*删除需求大厅*/
del(data) {
    return request._post('/shop/plus.requirement_hall.Index/del', data);
},
/*需求大厅详情*/
detail(data) {
  return request._post('/shop/plus.requirement_hall.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.requirement_hall.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.requirement_hall.Setting/getSetting', data, errorback);
    },
}
export default Requirement_hallApi;



// WEBPACK FOOTER //
// ./src/api/requirement_hall.js